import config from '../../config';
import readyDOM from '../../../utils/dom/readyDOM';
import PrepareWidget from '../../../widgets/prepare-widget';
import servicePlanPayload from '../helpers/servicePlanPayload';

/* eslint global-require: 0 */

const widget = new PrepareWidget({
  containerClass: 'hc-sem-medigap-plans',
  widgetClass: 'hc-sem-medigap-plan',
  widgetName: 'hc.sem.insertMedigapPlans',
});

/** @override */
widget.buildHTMLPlan = buildHTMLPlan;

const {widgetClass} = widget;

/**
 * @private
 * Creates a projection of the list of plans only with
 * the properties that will be used by `widget.buildHTMLPlan`
 *
 * @param {Array} plans: the list of plans
 * @returns {Array}
 */
function mapPlans(plans) {
  return plans.map(p => ({
    name: `${p.carrierName} ${p.planName}`,
    logo: p.carrierLogoNoT,
    price: p.rateWFormat,
    type: p.planTypeName,
    typeName: p.planName,
    redirectUrl: p.info.carrierWebsiteUrl,
  }));
}

/**
 * @private
 * Builds the HTML wrapper for each plan in the list of medigap plans.
 *
 * @param {Object} plan: the plan data
 * @returns {String}
 */
function buildHTMLPlan(plan) {
  return `<a class="${widgetClass}" href="${plan.redirectUrl}" target="_blank">
      <div class="${widgetClass}__body">
        <img class="${widgetClass}__logo" src="${plan.logo}">
        <hr class="${widgetClass}__hr orange">
        <div class="${widgetClass}__name" title="${plan.name}">${plan.name}</div>
        <div class="${widgetClass}__type">
          <span class="${widgetClass}__type-letter">${plan.type}</span>
          Medigap <span class="${widgetClass}__type-name">${plan.typeName}</span>
        </div>
      </div>
      <hr class="${widgetClass}__hr grey">
      <div class="${widgetClass}__cta">
        <div class="${widgetClass}__price">
          <span class="${widgetClass}__price-value">$${plan.price}</span>
          <br>
          <span class="${widgetClass}__price-period">PER MONTH</span>
        </div>
        <button type="button" class="${widgetClass}__button shadowed">SELECT PLAN</button>
      </div>
    </a>`;
}

/**
 * @public
 * Inserts the HTML block which renders medigap plans when the DOM is ready.
 *
 * @param {Object} options: An Object which contains the following options:
 *        - {String} title: text that will be heading plans widget
 *        - {String} disclaimer: disclaimer text, placed at the bottom
 *        - {String} divId: element id where the HTML will be inserted
 *        - {Number} howMany: How many plans should be inserted
 *        - {Function} payloadReducer: Function to alter the final payload sent to API
 * @throws {Error} if the element with `divId` does not exist.
 */
export default function insertMedigapPlans(options = {}) {
  options.css = require('./style.scss').toString();
  widget.setPayload(servicePlanPayload);
  const div = widget.configure(options);
  Promise.all([
    readyDOM(),
    widget.getPlans(`${config.plans}/MedigapSEM`, options.howMany, options.zipCode, options.payloadReducer),
  ]).then((responses) => {
    if (!responses[1].isSuccess) return [];
    const { data: { headerPlans: plans } } = responses[1];
    div.innerHTML = widget.buildHTMLBlock(mapPlans(plans));
    return plans;
  });
}
